'use client'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next-intl/link";
import { useLocale } from "use-intl";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

interface ButtonProps {
    class?: string
    disableDefaultClass?: boolean
    label: string
    link?: string
    type?: "button" | "submit" | "reset" | undefined
    thin?: boolean
    icon?: IconProp
    disabled?: boolean
}

export default function Button(props:ButtonProps) {

    const locale = useLocale();

    const defaultClass = `tracking-wide flex bg-primary ${props.thin ? "py-2 lg:py-3" : "p-5 px-14"} rounded-md lg:rounded-md font-bold xl:text-md 2xl:text-lg text-center justify-center ${locale == "business" && "text-offblack"}`;

    return (
        <>
            {props.link ? (
                <Link href={props.link} className={`${props.disableDefaultClass ? "" : defaultClass} ${props.class ? props.class : undefined}`}>
                    {props.icon ? (<FontAwesomeIcon icon={props.icon} className="mr-2 relative top-[3px]" />) : null}{props.label}
                </Link>
            ) : (
                <button disabled={props.disabled} type={props.type ? props.type : "button"} className={`${props.disabled && "cusror-not-allowed pointer-events-none opacity-30"} ${props.disableDefaultClass ? "" : defaultClass} ${props.class ? props.class : undefined}`}>
                    {props.icon ? (<FontAwesomeIcon icon={props.icon} className="mr-2 relative top-[3px]" />) : null}{props.label}
                </button>
            )}
       </>
    )
}
